import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { FI_SWIPE_DIRECTION, FiSwipeBase } from './fi-swipe-base';

@Directive({
    selector: '[fiSwipeRight]',
    standalone: false,
})
export class FiSwipeRightDirective extends FiSwipeBase {
    @Output() fiSwipeRight = new EventEmitter();

    protected _swipeEndCheck() {
        if (this.swipeDirection !== FI_SWIPE_DIRECTION.Horizontal) {
            return;
        }

        const deltaX = this.lastTouchEvent.touches[0].screenX - this.touchStartEvent.touches[0].screenX,
            deltaY = Math.abs(this.lastTouchEvent.touches[0].screenY - this.touchStartEvent.touches[0].screenY);
        if (deltaX > this.threshold && deltaX > deltaY) {
            this.fiSwipeRight.emit();
        }
    }
}
